import { createPinia, defineStore } from 'pinia';
import { axios } from '@/plugins/http-axios';
import Uri, { uri } from '@/store/uri';

import { useUserStore } from './user';
import { createLoggerPlugin } from '@/plugins/logger';

export interface IDocumentType2 {
  id: number;
  legalType: string;
  name: string;
  specialType?: {
    id: string;
  };
}

export interface IDocumentTypeItem {
  id: number;
  name: string;
  subtype: {
    id: string;
    name: string;
  };
  [key: string]: any;
}

export interface IDocumentTypeAll {
  id: string;
  name: string;
  items: IDocumentTypeItem[];
}

export const useMainStore = defineStore('mainStore', {
  state: () => ({
    uri: uri as Uri,
    documentTypes0: [] as IDocumentType2[],
    documentTypesAll0: [] as IDocumentTypeAll[],
  }),

  getters: {
    getUri: (state): Uri => state.uri,
    documentTypes: (state): IDocumentType2[] => state.documentTypes0,
    documentTypesAll: (state): IDocumentTypeAll[] => state.documentTypesAll0,
  },

  actions: {
    async logout() {
      const userStore = useUserStore();

      userStore.setAuthorized(undefined);
      clearLocalStorage();

      try {
        await axios.get(this.uri.logout);
        return Promise.resolve();
      } catch (e: any) {
        return Promise.reject(e);
      }
    },

    async getDocumentTypesAll(url?: string) {
      if (this.documentTypesAll.length) {
        return this.documentTypesAll;
      }

      const resp = await axios.get<IDocumentTypeAll[]>(url || this.uri.documenttype);
      this.documentTypesAll0 = resp.data;
      return this.documentTypesAll;
    },

    async getDocumentTypes(keys = [] as string[], url?: string) {
      if (!keys.length) {
        return;
      }

      const resp = await axios.get<IDocumentTypeAll[]>(url || this.uri.documenttype);
      this.documentTypes0 = resp.data
        .filter((docType) => keys.includes(docType.id))
        .reduce((sum, docType) => {
          return [
            ...sum,
            // eslint-disable-next-line no-unsafe-optional-chaining
            ...docType?.items.map((doc: any) => ({
              specialType: doc?.specialType !== undefined ? doc.specialType : null,
              legalType: docType.id,
              name: doc.name,
              id: doc.id,
            })),
          ];
        }, [] as IDocumentType2[]);
    },
  },
});

function clearLocalStorage() {
  const expandAsideMenu = localStorage.getItem('expandAsideMenu');
  localStorage.clear();
  if (expandAsideMenu) {
    localStorage.setItem('expandAsideMenu', expandAsideMenu);
  }
}

const pinia = createPinia();
if (process.env.NODE_ENV !== 'production') {
  pinia.use(createLoggerPlugin());
}
export default pinia;
